import { Fragment, useState, useEffect } from "react";
import "./Hero.css";
import PetAnimations from "../PetAnimations";
import heroImg1 from "../../assets/img/img_17.jpeg";
import heroImg2 from "../../assets/img/img_18.jpeg";
import heroImg3 from "../../assets/img/img_19.jpeg";
import heroImg4 from "../../assets/img/img_20.jpeg";
import heroImg5 from "../../assets/img/img_21.jpeg";
import heroImg6 from "../../assets/img/img_22.jpeg";

const HERO_IMGS = [heroImg1, heroImg2, heroImg3, heroImg4, heroImg5, heroImg6];

export default function Hero() {
  const [current, setCurrent] = useState(0);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setFading(true);
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % HERO_IMGS.length);
        setFading(false);
      }, 900);
    }, 7000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="hero" className="hero">
      {/* Fundo com gradiente + foto */}
      <div className="hero__bg" />
      <div
        className="hero__overlay"
        style={{ backgroundImage: `url(${heroImg1})` }}
      />

      {/* Pets flutuantes */}
      <PetAnimations />

      {/* Bolhas decorativas */}
      <div className="hero__blob hero__blob--1" />
      <div className="hero__blob hero__blob--2" />
      <div className="hero__blob hero__blob--3" />

      <div className="hero__container">
        {/* ── Lado esquerdo: texto ── */}
        <div className="hero__left">
          <h1 className="hero__title">
            Moda que
            <span className="hero__title-highlight">
              {" "}
              salva
              <br />
              vidas
            </span>
          </h1>

          <p className="hero__subtitle">
            Cada peça da Amanimal Shop financia abrigo, ração e cuidado para
            animais que aguardam uma família.
          </p>

          {/* Barra de confiança */}
          <div className="hero__trust">
            {[
              { value: "100%", label: "Revertido à ONG" },
              { value: "+260", label: "Padrinhos" },
              { value: "+43 Mil", label: "Seguidores" },
              { value: "+250", label: "Animais abrigados" },
            ].map(({ value, label }, i) => (
              <Fragment key={label}>
                {i > 0 && <div className="hero__trust-divider" />}
                <div className="hero__trust-item">
                  <strong>{value}</strong>
                  <span>{label}</span>
                </div>
              </Fragment>
            ))}
          </div>
        </div>

        {/* ── Lado direito: card visual ── */}
        <div className="hero__right">
          <div className="hero__card">
            <img
              className={`hero__card-img ${fading ? "hero__card-img--fading" : ""}`}
              src={HERO_IMGS[current]}
              alt="Gato resgatado pela ONG Amanimal"
            />

            {/* Dots indicadores */}
            <div className="hero__card-dots">
              {HERO_IMGS.map((_, i) => (
                <span
                  key={i}
                  className={`hero__card-dot ${i === current ? "hero__card-dot--active" : ""}`}
                />
              ))}
            </div>

            {/* Anel decorativo */}
            <div className="hero__card-ring" />
          </div>
        </div>
      </div>

      {/* Wave de transição */}
      <div className="hero__wave">
        <svg
          viewBox="0 0 1440 80"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0,40 C360,80 1080,0 1440,40 L1440,80 L0,80 Z"
            fill="#ffffff"
          />
        </svg>
      </div>
    </section>
  );
}
